import getThreadId from '@/lib/threads/getThreadId.js';

const removeThread = (threads = [], threadId = null) => {
  const normalizedThreadId = String(threadId || '').trim();

  if (!normalizedThreadId) {
    return Array.isArray(threads) ? threads : [];
  }

  return (Array.isArray(threads) ? threads : []).filter((thread) => {
    return getThreadId(thread) !== normalizedThreadId;
  });
};

export default removeThread;
